const menusEN = {
  // namespace your translation keys with "mns", i.e.
  // 'mns.lorem_ipsum': 'Lorem Ipsum'
}

export default menusEN
